import { useScrollLock } from '@vueuse/core';

import { stateFactoryKey, type StateFactory } from '@/injectionKeys';
import { sendGAWabunkaSearchModalOpenEvent } from '@/wabunka-src/common/utils/googleAnalytics/events/searchModalOpen';

/**
 * キーワード検索モーダルのオープン状態管理。
 *
 * useGlobalModal / utils/state.ts へ依存させず、stateFactory パターンで自己完結させる
 * （`wabunka-src` 外のファイルに影響を出さないため）。背景スクロールロックも内包する。
 */
export const useKeywordSearchModal = () => {
  const stateFactory = inject(stateFactoryKey) as StateFactory;
  const isOpen = stateFactory.create<boolean>('keywordSearchModal', false);

  const bodyElementRef = ref<HTMLElement | null>(null);
  onMounted(() => {
    bodyElementRef.value = document.body;
  });
  const isBackgroundLocked = useScrollLock(bodyElementRef);

  const open = () => {
    isOpen.value = true;
    sendGAWabunkaSearchModalOpenEvent();
  };
  const close = () => {
    isOpen.value = false;
  };

  watch(isOpen, () => {
    isBackgroundLocked.value = isOpen.value;
  });

  return { isOpen, open, close };
};
